var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.49944 16.0897C12.6909 16.0897 16.0887 12.6919 16.0887 8.50042C16.0887 4.30897 12.6909 0.911133 8.49944 0.911133C4.308 0.911133 0.910156 4.30897 0.910156 8.50042C0.910156 12.6919 4.308 16.0897 8.49944 16.0897Z",
    fill: "#426306",
    stroke: "#84C70D",
    strokeWidth: 1.82143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.46484 9.25949L7.67264 11.5363C8.71154 8.55194 9.57676 7.24239 11.5363 5.46484",
    stroke: "#84C70D",
    strokeWidth: 1.82143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.b0bc7415cc089d853fa58377eb4e387c.svg";
export { ForwardRef as ReactComponent };